export default "__VITE_ASSET__D$PRn5Du__"